const SCALE = {
  image: ''
}

export default SCALE
